const STOP_WIDTH = 10;

export const HALF_STOP_WIDTH = STOP_WIDTH / 2;

export const DEFAULT_STOP_REMOVAL_DROP = 50;

export const DEFAULT_WIDTH = 220;

export const DEFAULT_HEIGHT = 32;

export const DEFAULT_MAX_STOPS = 5;

export const DEFAULT_MIN_STOPS = 2;